import { render, staticRenderFns } from "./QQVideo.vue?vue&type=template&id=956f58f4&scoped=true&"
import script from "./QQVideo.vue?vue&type=script&lang=ts&"
export * from "./QQVideo.vue?vue&type=script&lang=ts&"
import style0 from "./QQVideo.vue?vue&type=style&index=0&id=956f58f4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956f58f4",
  null
  
)

export default component.exports